// Shopify App Bridge (embedded mode) helpers.
// The app is "embedded" only when Shopify admin passes a ?host= param.

const APP_BRIDGE_SRC = "https://cdn.shopify.com/shopifycloud/app-bridge.js";

export function getEmbeddedParams() {
  try {
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("host")) sessionStorage.setItem("shopify_host", qs.get("host"));
    if (qs.get("shop")) sessionStorage.setItem("shopify_shop", qs.get("shop"));
    return {
      host: qs.get("host") || sessionStorage.getItem("shopify_host"),
      shop: qs.get("shop") || sessionStorage.getItem("shopify_shop"),
    };
  } catch {
    return { host: null, shop: null };
  }
}

export function isEmbedded() {
  return Boolean(getEmbeddedParams().host);
}

let bridgeReady = null;

export function initAppBridge() {
  if (bridgeReady) return bridgeReady;
  bridgeReady = new Promise((resolve) => {
    if (window.shopify?.idToken) return resolve(true);
    const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;
    if (!apiKey || !isEmbedded()) return resolve(false);
    if (!document.querySelector('meta[name="shopify-api-key"]')) {
      const meta = document.createElement("meta");
      meta.name = "shopify-api-key";
      meta.content = apiKey;
      document.head.appendChild(meta);
    }
    const s = document.createElement("script");
    s.src = APP_BRIDGE_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return bridgeReady;
}

export async function getSessionToken() {
  if (!isEmbedded()) return null;
  const ok = await initAppBridge();
  if (!ok || !window.shopify?.idToken) return null;
  try {
    return await window.shopify.idToken();
  } catch {
    return null;
  }
}
